import React from 'react';
import util from 'Utils/commonUtil';

// Components
import LoadingIcon from 'Components/icons/LoadingIcon';

class BasicButton extends React.Component {
    render() {
        let {type, className, disabled, loading, isMouseDownEvent, testid} =
            this.props;
        let classNameList = {};

        type = type || 'default';

        if (className)
            className
                .split(' ')
                .forEach((item) => (classNameList[item] = true));

        console.log('BasicButton testid', testid);

        return isMouseDownEvent !== 'undefined' && isMouseDownEvent ? (
            <button
                {...util.mouseOfSingleTap(
                    (ev) =>
                        (!disabled || loading) &&
                        util.isFunction(this.props.onClickOfSingleTap) &&
                        this.props.onClickOfSingleTap(ev),
                    {
                        isPreventDefault: this.props.isPreventDefault,
                        isStopPropagation: this.props.isStopPropagation,
                    },
                )}
                className={util.getClassName({
                    'basic-btn': true,
                    'basic-primary-btn': type.toLowerCase() === 'primary',
                    'basic-danger-btn': type.toLowerCase() === 'danger',
                    'basic-default-btn': type.toLowerCase() === 'default',
                    'basic-info-btn': type.toLowerCase() === 'info',
                    ...classNameList,
                })}
                testid={testid ? testid : ''}
                disabled={disabled}>
                {loading ? <LoadingIcon /> : this.props.children}
            </button>
        ) : (
            <button
                {...util.clickOfSingleTap(
                    (ev) =>
                        (!disabled || loading) &&
                        util.isFunction(this.props.onClickOfSingleTap) &&
                        this.props.onClickOfSingleTap(ev),
                    {
                        isPreventDefault: this.props.isPreventDefault,
                        isStopPropagation: this.props.isStopPropagation,
                    },
                )}
                className={util.getClassName({
                    'basic-btn': true,
                    'basic-primary-btn': type.toLowerCase() === 'primary',
                    'basic-danger-btn': type.toLowerCase() === 'danger',
                    'basic-default-btn': type.toLowerCase() === 'default',
                    'basic-info-btn': type.toLowerCase() === 'info',
                    ...classNameList,
                })}
                testid={testid ? testid : ''}
                disabled={disabled}>
                {loading ? <LoadingIcon /> : this.props.children}
            </button>
        );
    }
}

export default BasicButton;
